import styles from './Modal.module.scss';
// Body Component
export interface ModalBodyProps {
  /**
   * Body content
   */
  children: React.ReactNode;
  
  /**
   * Optional custom class for the body
   */
  className?: string;
  
  /**
   * Whether to add padding to the body
   * @default true
   */
  padding?: boolean;
}

export const ModalBody: React.FC<ModalBodyProps> = ({ 
  children, 
  className = '',
  padding = true
}) => {
  return (
    <div className={`${styles.modalBody} ${padding ? styles.withPadding : ''} ${className}`}>
      {children}
    </div>
  );
};

